const currencyFormatter = new Intl.NumberFormat('en-US', {
	style: 'currency',
	currency: 'GBP', // pound
	minimumFractionDigits: 2,
})

export default currencyFormatter
